/* WHITE NOVEMBER — the intent popup (8 Sept 2026).

   Behaviour for sections/wn-intent-popup.liquid. Everything configurable is
   read off data- attributes on the container, so this file is never edited to
   change copy, timing, list or destinations.

   THE RULE THIS FILE OBEYS: the popup can never cost a subscriber. Every
   Klaviyo call is fire-and-continue. If Klaviyo is slow, blocked by a content
   blocker, or down entirely, the person still sees "thank you" and still gets
   their link, and the failure is logged to the console rather than shown to
   them. What they cannot get in that case is the email, which is Klaviyo's
   problem to have, not theirs to look at.

   WHY THREE CALLS AND NOT ONE.
     /client/profiles/       writes Interest immediately, so the property is on
                             the profile even if the subscription lags.
     /client/subscriptions/  is the only endpoint that records real marketing
                             consent and puts them on the list. Klaviyo answers
                             202 and processes it behind the scenes, which is
                             why the property is not left to this call alone.
     /client/events/         gives the answer its own metric, so a flow can be
                             triggered on it later without waiting for a
                             segment to rebuild.
   All three take company_id, the PUBLIC key. There is no private key in the
   browser and there must never be one. All three were fired against the live
   account on 8 Sept 2026 and answered 202.

   STORAGE. Two keys in localStorage: wn_intent_joined (permanent, set the
   moment they submit) and wn_intent_dismissed (a timestamp, honoured for the
   number of days set in the section). Both are wrapped, because Safari in
   private mode throws on write and an exception here would take the popup down
   on the browsers that need it most. */
(function () {
  'use strict';

  var root = document.querySelector('[data-wn-intent]');
  if (!root) return;

  var REVISION = '2024-10-15';
  var KEY_JOINED = 'wn_intent_joined';
  var KEY_DISMISSED = 'wn_intent_dismissed';

  var COMPANY = root.getAttribute('data-company') || '';
  var LIST = root.getAttribute('data-list') || '';
  var METRIC = root.getAttribute('data-metric') || 'Intent Captured';
  var PROPERTY = root.getAttribute('data-property') || 'Interest';
  var DELAY = parseInt(root.getAttribute('data-delay'), 10);
  var SCROLL = parseInt(root.getAttribute('data-scroll'), 10);
  var DAYS = parseInt(root.getAttribute('data-days'), 10);
  if (isNaN(DELAY)) DELAY = 8;
  if (isNaN(SCROLL)) SCROLL = 30;
  if (isNaN(DAYS)) DAYS = 30;

  var steps = {
    1: root.querySelector('[data-wn-step="1"]'),
    2: root.querySelector('[data-wn-step="2"]'),
    3: root.querySelector('[data-wn-step="3"]')
  };
  var form = root.querySelector('[data-wn-intent-form]');
  var field = root.querySelector('#wn-intent-email');
  var submit = root.querySelector('[data-wn-submit]');
  var errorEl = root.querySelector('[data-wn-error]');
  var chip = root.querySelector('[data-wn-chip]');
  var doneCta = root.querySelector('[data-wn-done-cta]');
  if (!form || !field || !steps[1]) return;

  var chosen = null;      /* { value, url, cta } */
  var opened = false;
  var lastFocus = null;
  var submitLabel = submit ? submit.textContent : 'Join';

  /* ---------- storage, wrapped ---------- */

  function read(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }
  function write(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) {}
  }

  /* ---------- should it appear at all ---------- */

  function suppressed() {
    if (read(KEY_JOINED)) return true;

    var dismissedAt = parseInt(read(KEY_DISMISSED), 10);
    if (dismissedAt && (Date.now() - dismissedAt) < DAYS * 86400000) return true;

    var path = (window.location.pathname || '').toLowerCase();
    /* The checkout is never a place to interrupt somebody, whatever is set. */
    if (path.indexOf('/checkout') === 0 || path.indexOf('/cart') === 0) return true;

    var hide = (root.getAttribute('data-hide-on') || '').split(',');
    for (var i = 0; i < hide.length; i++) {
      var frag = hide[i].trim().toLowerCase();
      if (frag && path.indexOf(frag) !== -1) return true;
    }
    return false;
  }

  /* ---------- open, close, steps ---------- */

  function show(n) {
    for (var k in steps) {
      if (steps[k]) steps[k].hidden = (String(k) !== String(n));
    }
  }

  function open() {
    if (opened) return;
    opened = true;
    lastFocus = document.activeElement;
    root.setAttribute('data-open', 'true');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var first = root.querySelector('[data-wn-option]');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
  }

  function close(remember) {
    root.setAttribute('data-open', 'false');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (remember) write(KEY_DISMISSED, String(Date.now()));
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* Focus stays inside the panel while it is open. Without this, tabbing walks
     out of the dialog and into the page behind it, which for a screen reader
     is the same as the popup not being a dialog at all. */
  function trap(e) {
    if (e.key !== 'Tab' || root.getAttribute('data-open') !== 'true') return;
    var nodes = [].filter.call(
      root.querySelectorAll('button, [href], input, select, textarea'),
      function (el) { return !el.disabled && el.offsetParent !== null; }
    );
    if (!nodes.length) return;
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Klaviyo ---------- */

  function post(path, body) {
    if (!COMPANY) return Promise.resolve();
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(COMPANY), {
      method: 'POST',
      mode: 'cors',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok && window.console) console.warn('[wn-intent] ' + path + ' -> ' + r.status);
      return r;
    });
  }

  function properties(value) {
    var props = {};
    props[PROPERTY] = value;
    props[PROPERTY + ' source'] = 'Site popup';
    props[PROPERTY + ' captured at'] = new Date().toISOString();
    return props;
  }

  function sendProfile(email, value) {
    return post('profiles', {
      data: {
        type: 'profile',
        attributes: { email: email, properties: properties(value) }
      }
    });
  }

  /* The only call that records consent. Klaviyo returns 202 and processes it
     asynchronously, so nothing downstream is allowed to depend on its body.

     THERE IS NO subscriptions BLOCK IN HERE, DELIBERATELY. The server-side API
     takes an explicit subscriptions/email/marketing/consent object on the
     profile; the CLIENT endpoint rejects it outright with 400 "'subscriptions'
     is not a valid field for the resource 'profile'". Verified against the
     live account on 8 Sept 2026. Posting to this endpoint at all IS the
     consent, and the custom_source below is what shows up in Klaviyo as how
     they joined. Add the block back and every sign-up silently fails. */
  function sendSubscription(email, value) {
    if (!LIST) return Promise.resolve();
    return post('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Site popup: ' + value,
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email, properties: properties(value) }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: LIST } } }
      }
    });
  }

  function sendEvent(email, value) {
    return post('events', {
      data: {
        type: 'event',
        attributes: {
          properties: {
            Interest: value,
            Source: 'Site popup',
            Page: window.location.pathname
          },
          metric: { data: { type: 'metric', attributes: { name: METRIC } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }
      }
    });
  }

  /* Tell the onsite script who this is, so everything they do from here on is
     attributed to the same profile the three calls above just wrote to. */
  function identify(email) {
    try {
      var k = window.klaviyo;
      if (k && typeof k.identify === 'function') k.identify({ $email: email });
      else { window.klaviyo = window.klaviyo || []; window.klaviyo.push(['identify', { $email: email }]); }
    } catch (e) {}
  }

  /* ---------- wiring ---------- */

  [].forEach.call(root.querySelectorAll('[data-wn-option]'), function (btn) {
    btn.addEventListener('click', function () {
      chosen = {
        value: btn.getAttribute('data-value') || '',
        url: btn.getAttribute('data-url') || '/',
        cta: btn.getAttribute('data-cta') || 'Continue'
      };
      if (chip) chip.textContent = chosen.value;
      show(2);
      window.setTimeout(function () {
        try { field.focus({ preventScroll: true }); } catch (e) { field.focus(); }
      }, 60);
    });
  });

  var back = root.querySelector('[data-wn-back]');
  if (back) back.addEventListener('click', function () { show(1); });

  [].forEach.call(root.querySelectorAll('[data-wn-intent-dismiss]'), function (btn) {
    btn.addEventListener('click', function () { close(true); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.getAttribute('data-open') === 'true') close(true);
    trap(e);
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (field.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (errorEl) { errorEl.textContent = 'That does not look like an email address.'; errorEl.hidden = false; }
      field.focus();
      return;
    }
    if (errorEl) errorEl.hidden = true;
    if (submit) { submit.setAttribute('aria-disabled', 'true'); submit.textContent = 'One moment'; }

    var value = chosen ? chosen.value : '';
    identify(email);

    /* Joined is written BEFORE the network, not after. If they close the tab
       mid-request the popup must still never ask them again. */
    write(KEY_JOINED, String(Date.now()));

    var calls = [
      sendProfile(email, value).catch(function () {}),
      sendSubscription(email, value).catch(function () {}),
      sendEvent(email, value).catch(function () {})
    ];

    function finish() {
      if (submit) { submit.removeAttribute('aria-disabled'); submit.textContent = submitLabel; }
      if (doneCta && chosen) {
        doneCta.setAttribute('href', chosen.url);
        doneCta.textContent = chosen.cta;
      }
      show(3);
      var cta = root.querySelector('[data-wn-done-cta]');
      if (cta) { try { cta.focus({ preventScroll: true }); } catch (e) {} }
    }

    var done = false;
    function once() { if (done) return; done = true; finish(); }
    Promise.all(calls).then(once, once);
    /* The thank you is never held hostage to a slow network. */
    window.setTimeout(once, 2500);
  });

  /* ---------- the trigger ---------- */

  if (suppressed()) return;

  if (DELAY >= 0) window.setTimeout(open, DELAY * 1000);

  if (SCROLL > 0) {
    var onScroll = function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h <= 0) return;
      if ((window.scrollY / h) * 100 >= SCROLL) {
        open();
        window.removeEventListener('scroll', onScroll);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
